module.exports = __webpack_public_path__ + "static/media/slide06.6f5bbf7e.jpg";